<template>
  <div>
    <div
      v-if="subsInfo.text"
      v-html="subsInfo.text"
      class="demo__font--16 demo__weight--400 demo__color--black demo__margin-top--16 demo__font-mobile--14"
    ></div>
    <div class="demo__margin-top--12" v-if="subsInfo.buttons.length">
      <a-button
        v-for="(button, index) in subsInfo.buttons"
        :key="index"
        v-bind:class="['demo__button--' + (button.type || 'base')]"
        class="demo__button demo__margin-top--12 demo__margin-right--12"
        @click="button.callback ? button.callback() : false"
      >
        <span v-if="button.icon?.pos === 'right'">
          {{ button.text }}
        </span>
        <i
          v-if="button.icon"
          class="fa-light"
          v-bind:class="[
            button.icon.class,
            'demo__margin-' +
              (button.icon.pos === 'left' ? 'right' : 'left') +
              '--8',
          ]"
          aria-hidden="true"
        ></i>
        <span v-if="!button.icon || button.icon.pos === 'left'">
          {{ button.text }}
        </span>
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subsInfo: {
      required: true,
      type: Object,
    },
  },
  created() {
    this.$accessModule("any", this);
  },
};
</script>
